module.exports = __webpack_public_path__ + "img/nav-design-classic.9ff6cea.jpg";